import input from '@/components/input'
import { numericInputValidation } from '@/mixins/numericInputValidation'

export default {
  name: 'InputText',
  extends: input,
  mixins: [numericInputValidation],

  data() {
    return {
      inputHasFocus: false,
      internalValue: ''
    }
  },

  props: {
    icon: {
      type: String,
      required: false
    },
    placeholder: {
      type: [String, Number],
      required: false
    },
    type: {
      type: String,
      required: false,
      validator: (v) => ['text', 'password', 'number'].indexOf(v) !== -1,
      default: 'text'
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    inputError: {
      type: [Boolean, Number],
      required: false
    },
    inputTextError: {
      type: String,
      required: false
    },
    placeHolderInput: {
      type: [String, Number],
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.shouldValidateNumericField(this.name) && (val === 0 || val === '0')) {
          this.internalValue = ''
          this.$nextTick(() => {
            this.$emit('input', '')
          })
        } else if (this.name === 'surfaceInput' && (val === 0 || val === '0')) {
          this.internalValue = ''
        } else {
          this.internalValue = val
        }
      }
    }
  },

  computed: {
    showRemoveIcon() {
      return this.removeIcon && this.internalValue && String(this.internalValue).length > 0
    }
  },

  methods: {
    numericInput() {
      if (this.type === 'number') {
        this.$nextTick(() => {
          const nodeList = document.querySelector('.inputText')
          if (nodeList) {
            nodeList.setAttribute('inputmode', 'numeric')
          }
        })
      }
    },

    handleInput(value) {
      if (this.type === 'number') {
        if (this.shouldValidateNumericField(this.name)) {
          const sanitized = this.sanitizeNumericValue(value)
          this.internalValue = sanitized
          this.$emit('input', sanitized)
        } else {
          let sanitized = value.replace(/[^\d.]/g, '')
          
          const parts = sanitized.split('.')
          if (parts.length > 2) {
            sanitized = parts[0] + '.' + parts.slice(1).join('')
          }
          
          if (sanitized.startsWith('0') && !sanitized.startsWith('0.') && sanitized.length > 1) {
            sanitized = sanitized.substring(1)
          }
          
          if (sanitized === '0') {
            sanitized = ''
          } else {
            const numValue = parseFloat(sanitized)
            if (!isNaN(numValue) && numValue === 0) {
              sanitized = ''
            }
          }
          
          this.internalValue = sanitized
          this.$emit('input', sanitized)
        }
      } else {
        this.internalValue = value
        this.$emit('input', value)
      }
    },

    handleKeydown(event) {
      if (this.type === 'number') {
        if (this.shouldValidateNumericField(this.name)) {
          this.preventInvalidNumericKeys(event)
        } else {
          const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End'
          ]
          
          if (allowedKeys.includes(event.key) || 
              event.ctrlKey || event.metaKey || event.altKey) {
            return
          }
          
          if (event.key === '-' || event.key === 'e' || event.key === 'E') {
            event.preventDefault()
            return
          }
          
          const currentValue = event.target.value || ''
          if (event.key === '0' && currentValue === '') {
            event.preventDefault()
            return
          }
          
          if (event.key === '0' && (currentValue === '.')) {
            event.preventDefault()
            return
          }
        }
      }
    }
  },

  mounted() {
    this.numericInput()
  }
}